import DOMPurify from 'dompurify'
import {Tooltip} from 'utils/bootstrap'

function getEventClassNames(event) {
  const classes = []
  const ext = event && event.extendedProps ? event.extendedProps : {}
  if (ext.recordType)
    classes.push(`gf-fc-event-${ext.recordType.toLowerCase()}`)
  if (ext.occurrenceType)
    classes.push(`gf-fc-event-${ext.occurrenceType.toLowerCase()}`)
  return classes
}

function eventContent(arg) {
  const titleText = arg.event.title || ''
  const extendedProps = arg.event.extendedProps || {}
  const iconHtml = extendedProps.iconHtml || ''

  const sanitizedTitle = DOMPurify.sanitize(titleText) // Plain text only
  const sanitizedIcon = DOMPurify.sanitize(iconHtml, {ALLOWED_TAGS: ['i', 'span'], ALLOWED_ATTR: ['class']}) // Future-proof for user content later

  return {
    html: `<div class="fc-event-main-frame gf-fc-event-custom">
            <div class="fc-event-title-container">
               <div class="fc-event-title fc-sticky">
                <span class="gf-fc-event-icon">${sanitizedIcon}</span>
                 <span class="gf-fc-event-title-text">${sanitizedTitle}</span>
               </div>
            </div>
         </div>`,
  }
}

function eventDidMount(data) {
  const extendedProps = data.event.extendedProps || {}
  const mainTooltip = DOMPurify.sanitize(data.event.title || '')
  const iconHtml = extendedProps.iconHtml || ''
  const additionalTooltip = extendedProps.additionalTooltip || ''
  const sanitizedTooltip = DOMPurify.sanitize(additionalTooltip)
  const sanitizedIcon = DOMPurify.sanitize(iconHtml, {
    ALLOWED_TAGS: ['i', 'span'],
    ALLOWED_ATTR: ['class'],
  })

  // add tooltips
  const tooltipHtml = `<div class="gf-fc-event-tooltip-container">
          <div class="gf-fc-event-tooltip-main">${mainTooltip}</div>
          <div class="gf-fc-event-tooltip-additional">
            <span class="gf-fc-event-icon">${sanitizedIcon}</span>
            <span class="gf-fc-event-text">${sanitizedTooltip}</span>
          </div>
        </div>`

  Tooltip.getOrCreateInstance(data.el, {title: tooltipHtml, html: true})

  // add event type and occurrence type as class names to list view items
  if (data.view.type === 'listWeek') {
    const classes = getEventClassNames(data.event)
    const listItem = data.el.closest('.fc-list-event')
    if (listItem && classes.length)
      listItem.classList.add(...classes)
  }
}

export {
  getEventClassNames,
  eventContent,
  eventDidMount,
}
